import React from "react";

const AssessmentTour = ({ setStepsEnabled, setHomeScreenWalkThroughPopup }) => {
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/activity_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to Assessment Section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              1. Multi-Media based Interactive Questions for Conceptual and Real-Life Learning.
            </p>
            <hr></hr>
            <p className="textColor2" >
              2. Take Assessments from Anywhere Anytime.
            </p>
            <hr></hr>
            <p className="textColor2" >
              3. Tracks Learning Progress and Benchmark Performance.
            </p>
            <hr></hr>
            <p className="textColor2" >
              4. Identifies Strengths, Weaknesses and Improvisation.
            </p>
            <hr></hr>
            <p className="textColor2" id="last-paragraph">
              5. Access all the Past Assessments Anytime and from Anywhere
            </p>
            <hr></hr>
          </div>

          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              id="assessmenttour"
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentTour;
